import * as React from 'react'
import styled from 'styled-components'
import Text from '@/components/content/Text'

interface Props {
  className?: string
  label?: string
  gap?: number
  children?: React.ReactNode
  block?: boolean
  direction?: 'row' | 'column'
}

function RadioGroup({ className, label, children, gap = 12, direction = 'column', block = false }: Props) {
  return (
    <RadioGroupWrap gap={gap} className={className} $block={block} $direction={direction}>
      {label && <Text kind="Body_14_bold">{label}</Text>}
      {children}
    </RadioGroupWrap>
  )
}

const RadioGroupWrap = styled.div<{ $block?: boolean; $direction: 'row' | 'column'; gap?: number }>`
  display: flex;
  flex-direction: ${({ $direction }) => ($direction === 'row' ? 'row' : 'column')};
  width: ${({ $block }) => ($block ? '100%' : 'auto')};
  ${({ gap }) => gap && `gap: ${gap}px;`}
`

export default RadioGroup
